import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import Layout from '../base/layout';

var LayoutController = /*#__PURE__*/function () {
  function LayoutController() {
    _classCallCheck(this, LayoutController);
  }

  _createClass(LayoutController, [{
    key: "getRectRange",
    value: function getRectRange(style) {
      var left = style.left,
          top = style.top,
          width = style.width,
          height = style.height,
          padding = style.padding;

      var _padding = _slicedToArray(padding, 4),
          paddingTop = _padding[0],
          paddingRight = _padding[1],
          paddingBottom = _padding[2],
          paddingLeft = _padding[3];

      return {
        left: left + paddingLeft,
        top: top + paddingTop,
        width: width - paddingLeft - paddingRight,
        height: height - paddingTop - paddingBottom
      };
    }
  }, {
    key: "create",
    value: function create(style) {
      var rectRange = this.getRectRange(style);
      var layout = new Layout(rectRange);
      this.layout = layout;
      return layout;
    }
  }, {
    key: "update",
    value: function update(style) {
      var rectRange = this.getRectRange(style);
      var layout = this.layout;
      layout.update(rectRange);
      return layout;
    }
  }]);

  return LayoutController;
}();

export default LayoutController;